import { createContext, useContext } from "react";

export const UpsellSubscriptionContext = createContext<PreSubscriptionContext>({
  step: 0,
  setStep: null,
  isModalOpen: false,
  setIsModalOpen: null,
  onNextStep: null,
  preSubscriptionData: null,
  preSubscriptionDataLoading: false,
  onSecondTimeMayBeLater: null,
  isMaybeLaterOpen: false,
  setIsMaybeLaterOpen: null,
  onFirstTimeMayBeLater: null,
});

export const useUpsellSubscriptionContext = () => useContext(UpsellSubscriptionContext);
